module.exports = __webpack_public_path__ + "img/logo-full-white.b57a7223.svg";